export default "__VITE_ASSET__fGjt8NOO__"